import Vue from 'vue'
import VueFlicking from '@egjs/vue-flicking'
import '@egjs/vue-flicking/dist/flicking.css'
import '@egjs/flicking-plugins/dist/pagination.css'
import '@egjs/flicking-plugins/dist/arrow.css'
Vue.use(VueFlicking)
